import get from 'lodash/get';

import COUNTRIES_COORDINATES from 'shared/modules/geolocation/constants/countriesCoordinates';

export default countryCode => {
  const coordinates = get(
    COUNTRIES_COORDINATES,
    countryCode.toUpperCase(),
    null
  );
  if (coordinates === null) return null;

  return { lat: coordinates[0], lng: coordinates[1] };
};
